module.exports = __webpack_public_path__ + "static/media/burger-4.0ebb6cc2.jpg";